import { useMutation } from '@tanstack/react-query';

import { AITerms } from '@graylog/enterprise-api';

const useAcceptAITerms = (onConsent: () => void) => {
  const { mutateAsync } = useMutation({
    mutationFn: AITerms.addConsent,
    onSuccess: onConsent,
  });

  return mutateAsync;
};

export default useAcceptAITerms;
